import useMasterKeyWorkflow from "./useMasterKeyWorkflow";

export default function useSurveyMasterKeyWorkflow(options) {
  return useMasterKeyWorkflow({ ...options, resetOutcome: "authenticated" });
}
